export default __webpack_public_path__ + "static/USMobBgImg-3c576a9beab517944380d97d37e274e4.png";